export default __webpack_public_path__ + "static/media/create-maps-plans-img.734a063e.jpg";